<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Document body -->
    <path
      d="M6 4H13.2222L19 8V20H6V4Z"
      :fill="fill"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linejoin="round"
    />
    <!-- Document corner fold -->
    <path
      d="M13 4V8H19"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linejoin="round"
    />
    <!-- Checkmark -->
    <path
      d="M10 13L11.8 14.8L15 12"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  fill: {
    type: String,
    default: 'none'
  },
  stroke: {
    type: String,
    default: '#1E4670'
  }
});
</script>
